import React from 'react';
import styled, { css } from 'styled-components';

import PeriodInput from '@/components/PeriodInput';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  selectCreditInitialValuesData,
  selectCreditPeriod,
  setCreditPeriod,
} from '@/store/reducers/detailed-car';
import { media } from '@/utils/mixin';

import { PeriodProps } from './types';

function Period({ creditType }: PeriodProps) {
  const dispatch = useTypedDispatch();
  const creditPeriod = useTypedSelector(selectCreditPeriod);
  const creditInitialValuesData = useTypedSelector(
    selectCreditInitialValuesData
  );

  const type = creditType === 'credit' ? 'CREDIT' : 'LEASING';

  return (
    <Component>
      <PeriodInput
        min={creditInitialValuesData?.[type]?.minPeriod ?? 0}
        max={creditInitialValuesData?.[type]?.maxPeriod ?? 0}
        value={creditPeriod}
        badge="месяцев"
        onChange={(value) => dispatch(setCreditPeriod(value))}
      />
    </Component>
  );
}

export default Period;

const Component = styled.div`
  flex: 1 1 65%;
  max-width: 65%;
  margin-left: 20px;

  ${media.tablet(css`
    flex: auto;
    max-width: none;
    margin: 20px 0 0;
  `)}
`;
